import { useState } from "react";
import { Plus, Trash2, ArrowUp, ArrowDown } from "lucide-react";
import { Input, GalleryField, DEFAULT_GALLERY_SETTINGS } from "./fields";
import { FicheOverlay, ItemCard, CardGrid } from "./Fiche";

const uid = () => `alb-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 6)}`;

const firstUrl = (images = []) => {
  const f = images[0];
  return f && typeof f === "object" ? f.url : f || "";
};

export const AdminGallery = ({ value = {}, onChange }) => {
  const [open, setOpen] = useState(null);
  const albums = value.albums || [];
  const setField = (k, v) => onChange({ ...value, [k]: v });
  const setAlbums = (arr) => onChange({ ...value, albums: arr });
  const patch = (i, p) => { const c = [...albums]; c[i] = { ...c[i], ...p }; setAlbums(c); };
  const move = (i, dir) => { const j = i + dir; if (j < 0 || j >= albums.length) return; const c = [...albums]; [c[i], c[j]] = [c[j], c[i]]; setAlbums(c); };
  const add = () => {
    setAlbums([...albums, { id: uid(), title: "Nouvel album", images: [], gallerySettings: { ...DEFAULT_GALLERY_SETTINGS, mode: "fixed" }, order: albums.length }]);
    setOpen(albums.length);
  };

  return (
    <div className="space-y-6" data-testid="admin-gallery-editor">
      <div className="rounded-lg border border-electric/20 bg-[#0a0a0a] p-4 text-sm text-secondary2">
        Organisez vos photos par <strong className="text-white">albums</strong> (tournages, festival, ateliers…). Les visiteurs les parcourent en plein écran sur <a href="/galerie" target="_blank" rel="noreferrer" className="text-electric">/galerie</a>.
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        <Input label="Sur-titre" value={value.eyebrow} onChange={(v) => setField("eyebrow", v)} />
        <Input label="Titre de section" value={value.heading} onChange={(v) => setField("heading", v)} />
      </div>
      <Input label="Introduction" value={value.intro} onChange={(v) => setField("intro", v)} />

      <div className="flex items-center justify-between border-t border-white/10 pt-5">
        <span className="text-[11px] tracking-[0.25em] uppercase text-electric">Albums photo ({albums.length})</span>
        <button onClick={add} data-testid="admin-add-album" className="inline-flex items-center gap-2 text-xs text-white/70 hover:text-electric"><Plus size={14} /> Ajouter un album</button>
      </div>

      {open !== null && albums[open] ? (
        <FicheOverlay testid="album-fiche" title={albums[open].title} subtitle={`Album · ${(albums[open].images || []).length} média(s)`} onClose={() => setOpen(null)}>
          <Input label="Titre de l'album" value={albums[open].title} onChange={(v) => patch(open, { title: v })} />
          <GalleryField label="Médias de l'album (photos & vidéos)" items={albums[open].images || []} settings={albums[open].gallerySettings || { ...DEFAULT_GALLERY_SETTINGS, mode: "fixed" }}
            onItemsChange={(v) => patch(open, { images: v })} onSettingsChange={(v) => patch(open, { gallerySettings: v })} testid={`album-gallery-${open}`} />
        </FicheOverlay>
      ) : (
        <>
          {albums.length === 0 && <p className="text-secondary2 text-sm">Aucun album. Cliquez sur « Ajouter un album ».</p>}
          <CardGrid testid="albums-cards">
            {albums.map((a, i) => (
              <ItemCard key={a.id || i} testid={`admin-album-${i}`}
                image={firstUrl(a.images)} title={a.title} subtitle={`${(a.images || []).length} média(s)`}
                onOpen={() => setOpen(i)}
                actions={
                  <>
                    <button onClick={() => move(i, -1)} title="Monter" className="p-2 rounded border border-white/10 text-white/40 hover:text-electric"><ArrowUp size={14} /></button>
                    <button onClick={() => move(i, 1)} title="Descendre" className="p-2 rounded border border-white/10 text-white/40 hover:text-electric"><ArrowDown size={14} /></button>
                    <button onClick={() => setAlbums(albums.filter((_, x) => x !== i))} title="Supprimer" className="p-2 rounded border border-white/10 text-red-400/70 hover:text-red-400 hover:border-red-400/40"><Trash2 size={14} /></button>
                  </>
                } />
            ))}
          </CardGrid>
        </>
      )}
    </div>
  );
};
